import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-left mt20" }
const _hoisted_2 = {
  key: 0,
  class: "w100 mt20 rad8 pad20"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "fs15 fw600" }, "担当者グループにオペレータのアカウントを割り当てる", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = { class: "dgrey fs12" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { key: 2 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "w100",
  style: {}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InstantRoomGroupConnectField = _resolveComponent("InstantRoomGroupConnectField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_ctx.rcm.room.room_type == `public_room`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              (_ctx.rcm.astag && _ctx.rcm.astag.name)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "「" + _toDisplayString(_ctx.rcm.astag.name) + "」", 1))
                : _createCommentVNode("", true),
              (_ctx.rcm.astag.can_connect_calendar)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                    _createTextVNode(" のそれぞれの担当者グループを特定のwaaqアカウント（オペレータ）に紐づけます。"),
                    _hoisted_8,
                    _createTextVNode("紐付けられたオペレータは、ログインすると自分で相談を受けられるかのオンオフのスイッチが利用できるようになります。 ")
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_9, " で担当オペレータを割り当てていきます。 ")),
              _createTextVNode(" 外部カレンダーに予定を入れる場合は、事前に調整カレンダーで担当者グループを作成してください。 ")
            ]),
            _hoisted_10,
            (_ctx.Util.isPresent(_ctx.mags))
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mags, (mag, magindex) => {
                    return (_openBlock(), _createBlock(_component_InstantRoomGroupConnectField, {
                      mag: mag,
                      members: _ctx.members,
                      magindex: magindex,
                      assignedMembers: _ctx.assignedMembers,
                      key: `${magindex}${_ctx.systemUpdatedAt}`,
                      onConnectMember: _ctx.connectMember,
                      onChangeActive: _ctx.changeActive
                    }, null, 8, ["mag", "members", "magindex", "assignedMembers", "onConnectMember", "onChangeActive"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.showAddMemberButton)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "w100 circle_button blueAround pointer centered rad10 mt15",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addNextField && _ctx.addNextField(...args)))
                }, " カレンダー連携していない担当者を追加 "))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _hoisted_12
    ])
  ]))
}